import { render, staticRenderFns } from "./Createadjust.vue?vue&type=template&id=b440417e&scoped=true"
import script from "./Createadjust.vue?vue&type=script&lang=js"
export * from "./Createadjust.vue?vue&type=script&lang=js"
import style0 from "./Createadjust.vue?vue&type=style&index=0&id=b440417e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b440417e",
  null
  
)

export default component.exports